import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';

import connect from "react-redux/es/connect/connect";
import ContentContainer from "../elements/ContentContainer";
import {getEconomieFeedback} from '../../helpers/feedbackHelpers';

class EconomyTotal extends Component {
  static propTypes = {
    title: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    feedbackCount: PropTypes.number,
    roundPoints: PropTypes.number,
    economy: PropTypes.number,
  }
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTitle(f) {
    if (f.belastingNaam) {
      return f.belastingNaam;
    } else if (f.ministerie) {
      return f.ministerie;
    } else if (f.ministerie_OE) {
      return f.ministerie_OE;
    } else if (f.ministerie_OE_2) {
      return f.ministerie_OE_2;
    } else if (f.type === "BELASTING") {
      return "sim_belastingkeuze"
    } else if (f.type === "BELEIDSKEUZE") {
      return f["titel_oplossing_" + this.props.gameState.language];
    }
  }

  renderList(title, sign, list) {
    if (!list) list = [];
    const total = list.reduce((r,f)=>r+f.economie.winstverliesglobas, 0);
    return (
      <div className={"table-section"}>
        <div className="title-bar">
          <div className={"left title"}>
            {title}
          </div>
          <div className={"right"}>
            {sign} {Math.abs(total)} {__('sim_miljard')}
          </div>
        </div>
        {list.map(f => (
          <div key={f.id} className={"subitem"}>
            <div className={"left title"}>
              {__('sim_effect_vanuit') + ': ' + __(this.getTitle(f))}
            </div>
            <div className={"right"}>
              {sign} {Math.abs(f.economie.winstverliesglobas)} {__('sim_miljard')}
            </div>
          </div>))}
      </div>
    );
  }

  render() {
    const { gameState, feedback } = this.props;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];

    const winstGlobas = getEconomieFeedback(feedback.prevRoundFeedbackData, 'profit');
    const verliesGlobas = getEconomieFeedback(feedback.prevRoundFeedbackData, 'loss');

    if(!gameState.prevRound || !feedback.prevRoundFeedbackData) return null;

    return (
      <ContentContainer className={'fade-in'}>
        <div className={"table-section"}>
          <div className="title-bar">
            <div className={"left title"}>
              {__('sim_earnedglobas')}
            </div>
            <div className={"right"}>
              {currentRoundGameState.earnedGlobas} {__('sim_miljard')}
            </div>
          </div>
        </div>

        {this.renderList(__('sim_winstglobas'), '+', winstGlobas)}
        {this.renderList(__('sim_verliesglobas'), '-', verliesGlobas)}

        <div className={"table-section"}>
          <span className={'divider'}>-------------------------------</span>
          <div className="title-bar">
            <div className={"left title"}>
              {__('sim_totalglobas')}
            </div>
            <div className={"right"}>
              {gameState.totalEconomy} {__('sim_miljard')}
            </div>
          </div>
        </div>
      </ContentContainer>
    );
  }
}

export default connect(({gameState, feedback, schoolClass}) => ({gameState, feedback, schoolClass}))(EconomyTotal);



// WEBPACK FOOTER //
// ./src/components/elements/EconomyTotal.js